import { RolesAuthInterface, RolesInfoInterface, RolesInterface } from "../interface/RolesInterface";

export const RolesInfoInit: RolesInfoInterface = {
    dutyGroupId: 0,
    dutyGroupName: "",
    codeRoleId: 0,
    codeDutyGroupTypeId: 0,
    codeOrgId: 0,
    dutyGroupRemark: "",
    groupId: 0,
    roleName: "",
    dutyGroupTypeName: "",
    orgName: "",
};

export const RolesAuthInit: RolesAuthInterface = {
    accountReadYn: "N",
    accountWriteYn: "N",
    accountsReceivableReadYn: "N",
    accountsReceivableWriteYn: "N",
    adjustmentReadYn: "N",
    adjustmentWriteYn: "N",
    analysisReadYn: "N",
    analysisWriteYn: "N",
    clientReadYn: "N",
    clientWriteYn: "N",
    contactReadYn: "N",
    contactWriteYn: "N",
    detailsReadYn: "N",
    detailsWriteYn: "N",
    dutyGroupId: 0,
    faqReadYn: "N",
    faqWriteYn: "N",
    inboundReadYn: "N",
    inboundWriteYn: "N",
    inventoryReadYn: "N",
    inventoryWriteYn: "N",
    itemReadYn: "N",
    itemWriteYn: "N",
    orderReadYn: "N",
    orderWriteYn: "N",
    outboundReadYn: "N",
    outboundWriteYn: "N",
    productReadYn: "N",
    productWriteYn: "N",
    projectReadYn: "N",
    projectWriteYn: "N",
    qnaReadYn: "N",
    qnaWriteYn: "N",
    rmaReadYn: "N",
    rmaWriteYn: "N",
    roleReadYn: "N",
    roleWriteYn: "N",
    salesReadYn: "N",
    salesWriteYn: "N",
    shipmentReadYn: "N",
    shipmentWriteYn: "N",
    tierReadYn: "N",
    tierWriteYn: "N",
    boardReadYn: "N",
    boardWriteYn: "N",
    taxReadYn: "N",
    taxWriteYn: "N",
    endReadYn: "N",
    endWriteYn: "N",
}

export const RolesDataInit: RolesInterface = {
    authorityVO: RolesAuthInit,
    dutyGroupVO: RolesInfoInit
}